<template>
  <div v-if="contract" class="background fill-height">
    <!--Header-->
    <div class="my-0 pa-0 d-flex flex-wrap white px-3">
      <Header ref="header" @reload="fetchContract" :contract="contract" />
    </div>
    <!--Finish Estates Header-->
    <v-col class="background d-flex flex-wrap px-3" height="100vh">
      <!-- TODO uncomment and implement this
        <div class="py-3">
        <v-select
          flat
          :items="dateSelect"
          :label="selected"
          v-model="selected"
          item-text="month"
          hide-details
          solo-inverted
          ></v-select>
      </div>
       -->
      <div class="fill-width">
        <Show @openRescission="openRescission" @reload="fetchContract" :contract="contract" />
      </div>
    </v-col>
  </div>
</template>

<script>
import Header from "@/components/contracts/show/Header";
import Show from "@/components/contracts/Show";
import { Contract } from "@/graphql/queries/contract";

export default {
  //Here you add your component name
  name: "Contract",
  data() {
    return {
      // dateSelect: [
      //  "November 2020",
      //  "December 2020"
      // ],
      // selected: "November 2020",

      contract: null
    };
  },

  components: {
    Show,
    Header
  },

  created() {
    this.fetchContract();
  },

  methods: {
    openRescission () {
      this.$refs.header.openRescission()
    },

    fetchContract() {
      this.$apollo
        .query({
          query: Contract,
          variables: {
            id: this.$route.params.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.contract = res.data.contract;
        });
    }
  }
};
</script>
